import {
  FinnairItineraryItem,
  FinnairItineraryItemFlight,
  FinnairItineraryItemType,
  FinnairLocation,
  ItineraryItem,
  ItineraryItemFlight,
  ItineraryItemLayover,
} from '@fcom/dapi/api/models';
import { isShortHaulFlight } from '@fcom/common/utils';

export const isFlight = (value: FinnairItineraryItem | ItineraryItem): value is FinnairItineraryItemFlight => {
  return value.type === FinnairItineraryItemType.FLIGHT;
};

export const isLongHaulLegAndAy = (
  itineraryArray: Array<ItineraryItemFlight | ItineraryItemLayover>,
  location: Record<string, FinnairLocation>
): boolean => {
  return itineraryArray
    .filter(isFlight)
    .filter((itinerary: FinnairItineraryItemFlight) => itinerary.operatingAirline.code === 'AY')
    .some((itinerary: FinnairItineraryItemFlight) => {
      const departureLocation = itinerary.departure.locationCode;
      const destinationLocation = itinerary.arrival.locationCode;

      const departureCountry = location[departureLocation].countryCode;
      const destinationCountry = location[destinationLocation].countryCode;

      return !isShortHaulFlight(
        { countryCode: departureCountry } as FinnairLocation,
        { countryCode: destinationCountry } as FinnairLocation
      );
    });
};
